const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export function downloadBlob(data: BlobPart, filename: string, mimeType = XLSX_MIME): void {
  const url = URL.createObjectURL(new Blob([data], { type: mimeType }));
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  a.click();
  URL.revokeObjectURL(url);
}

export function xlsxFilename(prefix: string): string {
  const now = new Date();
  const d = String(now.getDate()).padStart(2, "0");
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const y = now.getFullYear();
  return `${prefix}_${d}_${m}_${y}.xlsx`;
}
